import { useState } from "react";

import CommonImg from "@/components/Common/Img";
import CommonInput from "@/components/Common/Input";
import CommonButton from "@/components/Common/Button";

import BrownPencilIcon from "@/assets/images/brown-pencil-icon.png";

type Props = {
  data: string;
  onChange: (item: string) => void;
  onCancel: () => void;
};
export default function DashboardTargetAmountItem({
  data,
  onChange,
  onCancel,
}: Props) {
  const numberValue = Number(data);

  const [isEdit, setIsEdit] = useState<boolean>(false);

  const handleClickCancel = () => {
    setIsEdit(false);
    onCancel();
  };

  const handleChange = (value: number) => {
    onChange(value.toString());
  };

  return (
    <div className="flex items-center gap-1">
      {isEdit ? (
        <>
          <CommonInput
            type="number"
            className="text-right"
            defaultValue={numberValue}
            onChange={handleChange}
          />
          <span className="text-gray-B">원</span>
          <CommonButton
            label="취소"
            className="h-[20px] px-2 py-1 bg-gray-E outline-gray-D text-gray-A text-[10px] font-semibold flex items-center"
            onClick={handleClickCancel}
          />
          {/*<CommonButton*/}
          {/*  label="수정"*/}
          {/*  className="h-[20px] px-2 py-1 bg-dark-red text-white text-[10px] font-semibold flex items-center"*/}
          {/*  onClick={handleClickSave}*/}
          {/*/>*/}
        </>
      ) : (
        <>
          <span className="text-gray-A font-medium">
            {numberValue.toLocaleString()}
          </span>
          <span className="text-gray-B">원</span>
          <CommonImg
            className="size-2.5 cursor-pointer"
            src={BrownPencilIcon}
            alt="Pencil"
            onClick={() => {
              setIsEdit(true);
            }}
          />
        </>
      )}
    </div>
  );
}
